module.exports = __webpack_public_path__ + "img/ambiente.da8530e1.jpeg";